<template>
  <dev>
    <el-cascader
        style="width: 80%;"
        @change="handleChange"
        :model="indexes"
        :value="indexes"
        :options="options"
        :props="props"
        clearable></el-cascader>
  </dev>
</template>

<script>

export default {
  name: "AddressSelect",
  data() {
    return {
      options: [],
      props: {
        lazy: true,
        lazyLoad: this.lazyLoad
      }
    }
  },
  props: {
    indexes: {
      type: Array,
      require: true
    },
  },
  created() {
    this.findByParentId("b88cc57c-a0ea-42a0-8686-3216cdb15817", 0).then((item) => {
      this.options = item
    })
  },
  methods: {
    handleChange(value) {
      this.$emit("collback", value);
    },
    lazyLoad(node, resolve) {
      const {value, level} = node;
      this.findByParentId(value, level).then((items) => {
        resolve(items)
      })
    },
    findByParentId(_parentId, _level) {
      const _this = this;
      if (_parentId) {
        return new Promise(function (resolve, reject) {
          _this.$common.ajaxRequest({
            url: '/zone/findZoneByParentId',
            repeatKey: Math.random(),
            data: {
              parentId: _parentId
            },
            success(response) {
              let zones = [];
              if (response.items && response.items.length > 0) {
                for (let i = 0; i < response.items.length; i++) {
                  let zone = response.items[i]
                  zones.push({"value": zone.id, "label": zone.name, "leaf": _level >= 2})
                }
              }
              resolve(zones)
            }
          });
        })
      }
    },
  },
  watch: {
    indexes: function (val, oldVal) {
      if (oldVal.length === 0 && val.length === 3) {
        this.findByParentId(val[0], 0).then((item) => {
          this.options = item
        })
      }
    }
  }
}
</script>

<style scoped>

</style>
